<template>
  <div class="loan-channel">
    <!--导航部分-->
    <div class="nav" style="padding-bottom: 56px;">
      <van-nav-bar
              title="贷款渠道"
              fixed
              left-arrow
              @click-left="onClickLeft"
      />
    </div>
    <!--渠道列表-->
    <div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

        <div style="margin-top: 5px; margin-bottom: 1px;">

          <div class="van-cell" style="margin-bottom: 5px;" @click="goUrl('/loan/from?name=平安银行')">
            <div class="van-image" style="width: 80px; height: 85px; margin-right: 5px;">
              <img :src="require('../../assets/images/pingan.png')" class="van-image__img" style="object-fit: cover;">
            </div>

            <div class="van-cell__title">
              <span>平安银行官网-贷款 理财 信用卡 官方申请通道</span>
              <div class="van-cell__label van-multi-ellipsis--l2">平安银行-全称平安银行股份有限公司,是一家总部设在深圳的全国性股份制商业银行;致力于为客户提供理财，贷款，信用卡，生活等全方位的银行金融服务。</div>
            </div>
          </div>

          <div class="van-cell" style="margin-bottom: 5px;" @click="goUrl('/loan/from?name=浦发银行')">
            <div class="van-image" style="width: 80px; height: 85px; margin-right: 5px;">
              <img :src="require('../../assets/images/pufa.png')" class="van-image__img" style="object-fit: cover;">
            </div>

            <div class="van-cell__title">
              <span>浦发银行-贷款 在线申请通道</span>
              <div class="van-cell__label van-multi-ellipsis--l2">浦发信用卡_官方申请通道_线上线下刷卡获积分_24小时在线申请_3步拿卡</div>
            </div>
          </div>

        </div>

      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    'name': 'LoanChannel',
    data() {
        return {
          isLoading: false
        };
    },
    methods: {
        onClickLeft() {
            this.$router.push({path: '/home'});
        },
        goUrl(val) {
            return this.$router.push({path: val})
        },
        onRefresh() {
          setTimeout(() => {
            this.isLoading = false;
          }, 1000);
        }
    }
};
</script>

<style scoped>
.loan-channel >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.loan-channel >>> .van-nav-bar__text {
  color: #fff;
}
.loan-channel >>> .van-nav-bar__title {
  color: #fff;
}
.loan-channel >>> .van-nav-bar .van-icon {
  color: #fff;
}
.loan-channel >>> .van-button--primary {
  color: #fff;
  background-color: #ff8917;
  border: 0.02667rem solid #ff8917;
}
</style>
